import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Briefcase, Wrench, Info, Compass, Search, FileText } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import '../styles/ToolSidebar.css';

const ToolSidebar = () => {
  const { t } = useLanguage();
  const location = useLocation();

  const links = [
    { to: '/', label: t('home') || 'Home', icon: Home },
    { to: '/tours', label: t('tours') || 'Tours', icon: Compass },
    { to: '/start-business', label: t('startBusiness') || 'Start Business', icon: Briefcase },
    { to: '/tourismsoftware', label: t('tourismSoftware') || 'Tourism Software', icon: Wrench },
    { to: '/about', label: t('about') || 'About', icon: Info },
    { to: '/freelance-visa', label: t('freelanceVisa') || 'Freelance Visa', icon: FileText },
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <aside className="tool-sidebar" data-testid="tool-sidebar">
      <nav className="tool-sidebar-nav">
        {links.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className={`tool-sidebar-link ${isActive(link.to) ? 'tool-sidebar-active' : ''}`}
            data-testid={`sidebar-link-${link.to.replace('/', '') || 'home'}`}
          >
            <link.icon size={20} strokeWidth={1.8} className="tool-sidebar-icon" />
            <span className="tool-sidebar-label">{link.label}</span>
          </Link>
        ))}
      </nav>
    </aside>
  );
};

export default ToolSidebar;
